/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Andnmore2Inputs */

const en_andnmore2 = /** @type {(inputs: Andnmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`...and ${i?.count} more`)
};

const de_andnmore2 = /** @type {(inputs: Andnmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`…und ${i?.count} weitere`)
};

/**
* | output |
* | --- |
* | "...and {count} more" |
*
* @param {Andnmore2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const andnmore2 = /** @type {((inputs: Andnmore2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Andnmore2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_andnmore2(inputs)
	return de_andnmore2(inputs)
});
export { andnmore2 as "andNMore" }